<template>
  <div class="mt-5">
    <div class="row justify-content-center">
      <div class="col-12 col-md-7">

        <div class="card shadow-sm border-0">
          <div class="card-body text-center">

            <h3 class="card-title mb-3">
              <font-awesome-icon :icon="['fas', 'leaf']" class="me-2 text-success" />
              Activar tu Suscripción Inicial
            </h3>

            <p class="text-muted">
              <font-awesome-icon :icon="['fas', 'calendar-alt']" class="me-1" />
              <strong>Duración:</strong> 1 mes desde el momento del pago.
              <br />
              <font-awesome-icon :icon="['fas', 'sync-alt']" class="me-1" />
              <strong>Renovación:</strong> manual. No se renovará automáticamente.
            </p>

            <h4 class="mb-3 text-success">
              <font-awesome-icon :icon="['fas', 'dollar-sign']" class="me-1" />
              15.000 ARS
            </h4>

            <p class="text-muted small mb-4">
              Este pago te habilita el uso completo del sistema durante un mes. Si ya tenés una suscripción activa, se
              suma automáticamente otro mes adicional.
            </p>

            <ul class="list-group text-start mb-4">
              <li class="list-group-item border-0">
                <font-awesome-icon :icon="['fas', 'check-circle']" class="me-2 text-success" />
                Trazabilidad completa de cultivo y producción.
              </li>
              <li class="list-group-item border-0">
                <font-awesome-icon :icon="['fas', 'tasks']" class="me-2 text-success" />
                Planificación y gestión de tareas por lote y planta.
              </li>
              <li class="list-group-item border-0">
                <font-awesome-icon :icon="['fas', 'chart-line']" class="me-2 text-success" />
                Indicadores visuales y estadísticas por proyecto.
              </li>
              <li class="list-group-item border-0">
                <font-awesome-icon :icon="['fas', 'balance-scale']" class="me-2 text-success" />
                Cumplimiento normativo (GACP / GMP / ARICCAME).
              </li>
              <li class="list-group-item border-0">
                <font-awesome-icon :icon="['fas', 'users']" class="me-2 text-success" />
                Gestión de personal y tareas operativas.
              </li>
            </ul>

            <button class="btn btn-primary btn-lg w-100" @click="generarPago">
              <font-awesome-icon :icon="['fas', 'credit-card']" class="me-2" />
              Pagar y Activar Sistema
            </button>

            <div class="mt-4">
              <p class="text-muted small mb-1">
                Se abrirá una ventana de <strong>MercadoPago</strong> para completar el pago de forma segura.
              </p>
              <div id="wallet_container" class="text-center mt-2"></div>
            </div>

            <small class="text-muted d-block mt-3">
              <font-awesome-icon :icon="['fas', 'lock']" class="me-1" />
              Pago 100% seguro y encriptado con MercadoPago.
            </small>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import axios from '@/axios'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

const producto = ref({
  title: 'Suscripción Mensual',
  quantity: 1,
  price: 15000
})

const generarPago = async () => {
  try {
    const { data } = await axios.post('/api/mercadopago_create_preference', producto.value)

    if (!window.MercadoPago) {
      await new Promise((resolve, reject) => {
        const script = document.createElement('script')
        script.src = 'https://sdk.mercadopago.com/js/v2'
        script.onload = resolve
        script.onerror = reject
        document.head.appendChild(script)
      })
    }

    const mp = new window.MercadoPago(process.env.VUE_APP_MP_PUBLIC_KEY, { locale: 'es-AR' })

    mp.checkout({
      preference: { id: data.id },
      autoOpen: true // 👈 abre directo
    })


  } catch (error) {
    console.error('❌ Error al generar la preferencia de pago:', error)
  }
}

onMounted(() => {
  if (!window.MercadoPago) {
    const script = document.createElement('script')
    script.src = 'https://sdk.mercadopago.com/js/v2'
    document.head.appendChild(script)
  }
})
</script>

<style scoped>
.card-title {
  font-weight: 600;
}
</style>
